import i18n from "i18next";
import i18nLangDet from "i18next-browser-languagedetector";
import resources from '../locales';

import $i18n from "jquery-i18next";
import {DateTimePickerEditable} from "../../cloudui/libs/jquery-editable/modules/datepicker.editable";

let hasExpired = false;
const $ = require('jquery');
const _ = require('underscore');
const Handlebars = require('handlebars');
require('./handlebars-helpers');
require('libs/bootstrap-3.3.2-dist/js/bootstrap.min');
require('libs/bootstrap-star-rating/js/star-rating');
require('jquery-datetimepicker');
require("jquery-datetimepicker/jquery.datetimepicker.css");

const moment = require('moment');
const libphonenumber = require("libphonenumber");
var callingcode = libphonenumber.PhoneNumberUtil.getInstance();
var exampleNumber = '999999999';


$(function () {
    $i18n.init(i18n, $, {
        tName: 't', // --> appends $.t = i18next.t
        i18nName: 'i18n', // --> appends $.i18n = i18next
        handleName: 'i18n', // --> appends $(selector).localize(opts);
        selectorAttr: 'data-i18n', // selector for translating elements
        targetAttr: 'i18n-target', // data-() attribute to grab target element to translate (if diffrent then itself)
        optionsAttr: 'i18n-options', // data-() attribute that contains options, will load/set if useOptionsAttr = true
        useOptionsAttr: false, // see optionsAttr
        parseDefaultValueFromContent: true // parses default values from content ele.val or ele.text
    });
    i18n.use(i18nLangDet)
        .init({
            fallbackLng: 'el',
            initImmediate: false,
            resources,
            whitelist: ['en', 'el'],
            detection: {
                order: ['localStorage', 'querystring', 'cookie', 'navigator', 'htmlTag']
            }
        }, main.bind(this));
});

const isComponent = (type) => ["SurveyImage", "SurveyFormattedText", "SurveySocialShare", "SurveySocialFollow"].indexOf(type) > -1;

async function main(t) {
    $('[data-i18n]').i18n();
    $('html').attr('lang', i18n.options.lng);

    const $thank = $('#thank-you-1');
    const $thank2 = $('#thank-you-2');
    const $thank3 = $('#thank-you-3');
    const $submitbutton = $(".submitbutton");

    const templates = {
        SurveyStarRating: Handlebars.compile(require('./templates/survey.star.rating.template.htm')),
        SurveyFreeText: Handlebars.compile(require('../../common/templates/survey.free.text.template.htm')),
        SurveyMultipleChoice: Handlebars.compile(require('./templates/survey.multiple.choice.template.htm')),
        SurveyImage: Handlebars.compile(require('./templates/survey.image.template.htm')),
        SurveyDate: Handlebars.compile(require('../../common/templates/survey.date.template.htm')),
        SurveyFormattedText: Handlebars.compile(require('../../common/templates/survey.formatted.text.template.htm')),
        CustomFieldComponent: Handlebars.compile(require('../../common/templates/custom.field.template.htm')),
        CustomFieldMultipleChoiceComponent: Handlebars.compile(require('../../common/templates/custom.field.multiplechoice.template.htm'))
    };

    const isNotColor = (str) => !/#[0-9a-fA-F]{3,6}/.test(str);
    const isCustomImage = str => /^[0-9a-fA-F]{24}$/.test(str);

    const match = window.location.href.match(/#(.*)$/);
    const code = match ? match[1] : null;

    if (!code) {
        $("#code").hide();
        console.log("Code missing");
        return;
    }

    const url = code.includes("anonymous") ? `/CampaignCloud/uurl/survey/${code.replace("anonymous/", "")}` : `/CampaignCloud/uurl/${code}`;

    try {
        const [surveyConfig, answerList, {hasExpired: isExpired, endDate}] = await $.ajax({
            type: "POST",
            url,
            data: {action: "getconfig"},
            dataType: "json",
        });

        //TODO check when the hasExpired field takes a String value
        hasExpired = isExpired === "true" || isExpired === true;

        const data = surveyConfig;
        let movedPercentage = data.backgroundImagePosition ? data.backgroundImagePosition : 0;

        const $expirationDate = $("#expirationDate");
        if (endDate) {
            const formattedDate = Handlebars.helpers.timestamp(new Date(endDate), "L HH:mm");
            $expirationDate.text(i18n.t("expires") + formattedDate);
        } else {
            $expirationDate.text(i18n.t("expires") + i18n.t("never"));
        }
        $expirationDate.show();

        if (hasExpired && answerList == null) {
            $submitbutton.prop("disabled", true);
            $submitbutton.off("click");
            $("#expired").show();
        }

        if (isCustomImage(data.backgroundColor)) {
            const $headerImage = $("#headerImage");
            $headerImage.css("background-image", `url(${url}?action=getbgimage)`);
            $headerImage.css("background-position", `0px ${movedPercentage * 100}%`);
        } else {
            $('#surveycontainerB').addClass(data.backgroundColor);
        }

        if (isNotColor(data.fontColor)) {
            $('body').addClass(data.fontColor);
        } else {
            $('body').css("background-color", data.fontColor);
        }


        $thank.text(parseChangeLineCharacters(data.endTitle));
        $thank2.text(parseChangeLineCharacters(data.endText));
        $thank3.text(parseChangeLineCharacters(data.endFooter));
        document.title = i18n.t("surveyunregisteredtitle", {code: code});
        if (data.logoContentId) {
            const $logo = $('#logo');
            $logo.show();
            $logo.attr("src", `${url}?action=getlogo`);
        }

        const components = data.components;
        const questions = [];
        let qid = 0;
        components.forEach((val, i) => {
            let markuptext;
            if (!isComponent(val.type)) {
                questions.push(val);
                qid++;
            }
            if (answerList != null && !isComponent(val.type)) {
                markuptext = templates[val.type]({
                    i: i,
                    q: val,
                    ans: answerList.surveyAnswerList[qid]
                });
            } else {
                markuptext = templates[val.type]({i: i, q: val, ans: null, url});
            }

            const markup = $(markuptext);
            if (val.type === "SurveyStarRating") {
                $(markup).find('.star-rating').rating({
                    language: i18n.options.lng,
                    min: 0,
                    max: val.size,
                    stars: val.size,
                    step: 1,
                    size: 'lg'
                });
            }
            $('#components').append(markup);
        });

        if (answerList != null) {
            answerList.surveyAnswerList.forEach(function (val, i) {
                const normalIndex = components.indexOf(questions[i]);
                if (val.type === "SurveyAnswerMultipleChoice") {
                    for (let j = 0; j < val.choices.length; j++) {
                        const sel = `.q_${normalIndex}_li_${val.choices[j]}`;
                        $(sel).find(`.choice${normalIndex}`).prop("checked", true);
                    }
                }
                $(`#q${normalIndex}`).find(`.choice${normalIndex}`).prop("disabled", true);
            });
        }

        if (answerList != null && answerList.surveyAnswerList.length > 0) {
            $submitbutton.prop("disabled", true);
            $submitbutton.off("click");
            const $submitted = $('#submitted');
            $submitted.html(i18n.t("submitted"));
            $submitted.show();
            $thank.hide();
            $thank2.hide();
            $thank3.hide();
            $('#thank-you-all').hide();
        }

        $('textarea').each(function () {
            this.setAttribute('style', `height:${this.scrollHeight}px;overflow-y:hidden;`);
        }).on('input', function () {
            this.style.height = 'auto';
            this.style.height = `${this.scrollHeight}px`;
        });

        // Adding Events.

        $('.email').on('input', _.debounce(function (event) {
            var value = event.currentTarget.value;
            checkEmail(value);
        }, 800));
        $('.mobile').on('input', _.debounce(function (event) {
            var value = event.currentTarget.value;
            checkMobile(event, value);
        }, 200));
        $('.decimal').on('input', _.debounce(function (event) {
            var value = event.currentTarget.value;
            checkNotANumber(event.currentTarget, value);
        }, 200));
        $('.text').on('input', _.debounce(function (event) {
            var value = event.currentTarget.value;
            checkInputLength(event.currentTarget, value);
        }, 200));
        $('.surveymultiplechoicelistcontainer').on('input', function (event) {
            const $select = $(event.currentTarget);
            if ($select.children('input').prop("checked") != true) {
                $select.children('input').prop("checked", false);
            } else {
                $select.children('input').prop("checked", true);
            }
        });
        $('.surveymultiplechoicelistselect').on('change', function (event) {
            const $select = $(event.currentTarget);
            $select.prop("checked", true);
        });
        var maxDateForPicker = new Date();
        maxDateForPicker = new Date(maxDateForPicker.getFullYear() - 1, maxDateForPicker.getMonth(), maxDateForPicker.getDate());
        const $date = $(".surveytextarea.date");
        $date.datetimepicker({

            onShow: function (current_time, input, inst) {
                DateTimePickerEditable.customButton(inst.currentTarget, $date, {
                    customButton: [{
                        classes: "clear dateButton button bg-cyan fg-white bg-hover-orange border small",
                        id: "clearButton1",
                        label: "Clear",
                    }, {
                        classes: "dataNullifyButton eventDateButton button bg-cyan fg-white bg-hover-orange border small",
                        id: "closeButton",
                        label: "Close",
                    }],
                    onblur: 'ignore'
                });

                var comp_id = `${input[0].id}`;
                $(window).bind("datetimepicker:clearDateButtonClicked", {c_id: comp_id}, function (ev, attrType, objectId, picker) {
                    if (attrType === 'date') {
                        $(`#${ev.data.c_id}`).datetimepicker('reset');
                    }
                });
            },
            format: i18n.t("$dateformat"),
            closeOnDateSelect: true,
            scrollInput: false,
            todayButton: false,
            timepicker: false,
            yearStart: 1900,
            yearEnd: new Date().getFullYear() - 1,
            setDate: new Date("23/03/2016"),
            minDate: new Date("1/1/1900"), /*lower boundary*/
            maxDate: maxDateForPicker /*upper boundary= today*/
        }).focus(function () {
            $('.surveytextarea.date').datetimepicker('setDate', maxDateForPicker);
        });

        const $datetime = $(".surveytextarea.datetime");
        $datetime.datetimepicker({
            onShow: function (current_time, input, inst) {

                DateTimePickerEditable.customButton(inst.currentTarget, $datetime, {
                    customButton: [{
                        classes: "clear dateButton button bg-cyan fg-white bg-hover-orange border small",
                        id: "clearButton1",
                        label: "Clear",
                    }, {
                        classes: "dataNullifyButton eventDateButton button bg-cyan fg-white bg-hover-orange border small",
                        id: "closeButton",
                        label: "Close",
                    }],
                    onblur: 'ignore'
                });

                var comp_id = `${input[0].id}`;
                $(window).bind("datetimepicker:clearDateButtonClicked", {c_id: comp_id}, function (ev, attrType, objectId, picker) {
                    if (attrType === 'datetime') {
                        $(`#${ev.data.c_id}`).datetimepicker('reset');
                    }
                });
            },
            format: i18n.t("$datetimeformat"),
            closeOnDateSelect: true,
            scrollInput: false,
            todayButton: true,
            timepicker: true,
            yearStart: 1900,
            setDate: new Date("23/03/2016"),
            minDate: new Date("1/1/1900"), /*lower boundary*/
        }).focus(function () {
            $('.surveytextarea.datetime').datetimepicker('setDate', new Date());
        });


        $submitbutton.click(handleSubmit.bind(this, components));

        console.log(data);


    } catch (e) {
        $("#failure").show();
        console.log(e);
    }

    async function handleSubmit(components, event) {
        if (hasExpired) {
            return;
        }
        let answers = [];
        let valid = true;
        let bday;

        components.forEach(function (val, i) {
            const $input = $(`#q${i}`);
            var ans = $input.val();

            if (val.type === "SurveyStarRating") {
                if (val.required && ans === "0") {
                    $(`#qc${i}`).fadeIn(100).fadeOut(100).fadeIn(100);
                    valid = false;
                } else
                    answers.push({rating: parseInt(ans)});

            } else if (val.type === "SurveyFreeText" || val.type === "CustomFieldComponent") {
                if (val.type === "CustomFieldComponent" && $input.hasClass("datetime")) {
                    const date = moment(ans, i18n.t("momentDateTimeFormat"));
                    ans = date.isValid() ? date.valueOf().toString() : "";
                }
                if (val.required && ans === "") {
                    $input.fadeIn(100).fadeOut(100).fadeIn(100);
                    valid = false;
                } else
                    answers.push({
                        freetext: ans,
                        kind: val.kind
                    });

            } else if (val.type === "SurveyMultipleChoice") {

                const checkedChoices = {};
                const select = $(`.single-select-${i}`);
                if (select.length) {
                    let selOpt;
                    select.find("[real]").each(function (ind, el) {
                        if ($(el).val() === select.val())
                            selOpt = ind;
                    });
                    if (selOpt !== undefined) {
                        checkedChoices["answer0"] = selOpt;
                    } else if (val.required) {
                        $input.fadeIn(100).fadeOut(100).fadeIn(100);
                        valid = false;
                    }
                } else {
                    const $checkedChoice = $(`.choice${i}:checked`);
                    const len = $checkedChoice.length;

                    if (val.required && len === 0) {
                        $input.fadeIn(100).fadeOut(100).fadeIn(100);
                        valid = false;
                    }
                    const s1 = $(`.choice${i}`);
                    for (let j = 0; j < len; j++) {
                        checkedChoices[(`answer${j}`)] = $(s1).index($($checkedChoice[j]));
                    }
                }
                answers.push(checkedChoices);
            } else if (val.type === "SurveyDate") {
                if (ans)
                    bday = `date:${moment(ans, i18n.t("momentDateTimeFormat")).format('YYYY-MM-DD')}`;
                else {
                    bday = `date:null`;
                    valid = valid && !val.required;
                }
                answers.push({
                    date: bday,
                    kind: val.kind
                });
            } else if (val.type === "CustomFieldMultipleChoiceComponent") {
                let value;
                const select = $(`.single-select-${i}`);
                if (select.length) {
                    const $checkedSelect = select.find(":checked");
                    if ($checkedSelect.val() !== "") {
                        value = $checkedSelect.val();
                    } else if (val.required) {
                        $input.fadeIn(100).fadeOut(100).fadeIn(100);
                        valid = false;
                    }
                } else {
                    const $checkedChoice = $(`.choice${i}:checked`);
                    value = $checkedChoice.val();
                    const len = $checkedChoice.length;

                    if (val.required && len === 0) {
                        $input.fadeIn(100).fadeOut(100).fadeIn(100);
                        valid = false;
                    }
                }
                answers.push({
                    freetext: value,
                    kind: val.kind
                });

            }
    });


        if (!valid) {
            alert(i18n.t("requiredfields"));
            return;
        }
        answers = {answers: answers};

        const $submitbutton = $(event.currentTarget);
        $submitbutton.prop("disabled", true);
        try {
            const data = await $.ajax({
                type: "POST",
                url,
                data: {action: "submit", answers: JSON.stringify(answers)},
                dataType: "json"
            });
            console.log(data);
            $('#thank-you-1').show();
            $('#thank-you-2').show();
            $('#thank-you-3').show();
            $('#thank-you-all').show();
            components.forEach(function (val, i) {
                const input = $(`#q${i}`);
                if (val.type === "SurveyStarRating") {
                    $(input).rating('refresh', {disabled: true});
                } else if (val.type === "SurveyFreeText") {
                    $(input).prop("disabled", true);
                } else if (val.type === "SurveyMultipleChoice") {
                    const $choice = $(`.choice${i}`);
                    const len = $choice.length;

                    for (let j = 0; j < len; j++) {
                        $($choice[j]).prop("disabled", true);
                    }
                }
            });

        } catch (e) {
            $submitbutton.prop("disabled", false);
            $("#failure").show();
            console.log(e);
        }
    }

}

$('textarea').each(function () {
    this.setAttribute('style', `height:${this.scrollHeight}px;overflow-y:hidden;`);
}).on('input', function () {
    this.style.height = 'auto';
    this.style.height = `${this.scrollHeight}px`;
});


function checkEmail(value) {
    value = value.trim();
    var re = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,63}$/i;
    var isEmailValid = value != null && value.length > 0 && re.test(value);
    if (isEmailValid) {
        onValid();
    } else {
        onInvalid();
    }
}

function checkNotANumber(e, input) {
    input = input.trim();
    var re = /^-?[0-9]+([.][0-9]+)?$/g;
    if (input !== '' && !re.test(input)) {
        $(e).parent().find('#error-decimal').show();
        $('.submitbutton').prop("disabled", true);
    } else {
        $(e).parent().find('#error-decimal').hide();
        $('.submitbutton').prop("disabled", false);
    }
}

function checkMobile(event, value) {
    value = value.trim();
    if (value.indexOf("00") === 0) {
        value = `+${value.substring(2)}`;
    }

    const $msisdn = $("#msisdn-flag");
    const $email = $('#email-msisdn');
    if (value.length > 0) {
        try {
            const parsedPhoneNum = callingcode.parseAndKeepRawInput(value, callingcode.defaultCountryCode);
            const c = callingcode.getRegionCodeForNumber(parsedPhoneNum);
            const numberType = callingcode.getNumberType(parsedPhoneNum);

            if (numberType === 1 || numberType === 2) {
                $msisdn.removeClass();
                $msisdn.addClass("flag-icon");
                $msisdn.addClass(`flag-icon-${c.toLowerCase()}`);
                value = callingcode.format(parsedPhoneNum, libphonenumber.PhoneNumberFormat.E164);
                $msisdn.show();
                $(event.currentTarget).val(value);
                onMobileValid();
            } else {
                throw new Error("Unacceptable number type");
            }
        } catch (e) {
            console.info(`Not a valid cellphone: ${value} ${e}`);
            $email.removeClass('required-input');
            $email.removeClass('valid-input');
            $email.addClass('invalid-input');
            $email.addClass('confirm-failure-input-borders');
            $('#error-mobile').text(i18n.t("msisdnerror", {examplenumber: exampleNumber}));
            $msisdn.hide();
            onMobileInvalid();
        }
    } else {
        $msisdn.removeClass();
    }
}

// Valid mobile function
function onMobileValid() {
    if (!hasExpired) {
        $('.submitbutton').prop("disabled", false);
    }
    $('#error-mobile').hide();
}

// Invalid mobile function
function onMobileInvalid() {
    $('.submitbutton').prop("disabled", true);
    $('#error-mobile').text(i18n.t("msisdnerror", {examplenumber: exampleNumber})).show();
}

// Valid email function
function onValid() {
    if (!hasExpired) {
        $('.submitbutton').prop("disabled", false);
    }
    $('#error-email').hide();
}

// Invalid email function
function onInvalid() {
    $('.submitbutton').prop("disabled", true);
    $('#error-email').text(i18n.t("malformedEmail")).show();
}

function checkInputLength(e, input) {
    if (!$(e).data("maxlength")) return;
    var maxLength = parseInt($(e).data("maxlength"));
    if (input.length > maxLength) {
        $(e).parent().find('#error-varchar').show();
        $('.submitbutton').prop("disabled", true);
    } else {
        $(e).parent().find('#error-varchar').hide();
        $('.submitbutton').prop("disabled", false);
    }
}

function parseChangeLineCharacters(rawText) {
    return rawText.replace(/\\n/g, "\n");
}